import type { CardTypeDto } from "../../types/CardTypeDto";
import type { CardTypeEntity } from "../../types/CardTypeEntity";

export const cardTypeDtoToEntity = ({ dynamicProperties, ...rest }: Readonly<CardTypeDto>): CardTypeEntity => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "CHECKBOX" ? propValue.value === "true" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern ?? "",
            readOnly: propValue.readOnly || false,
            mandatory: propValue.mandatory || false,
            value,
        };
    });

    return {
        ...rest,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
